import { Brand, createBranded } from '@deltasierra/type-utilities';

export type EmailTemplateSettingsDocumentAssetId = Brand<string, 'EmailTemplateSettingsDocumentAssetId'>;
export const EmailTemplateSettingsDocumentAssetId = createBranded<EmailTemplateSettingsDocumentAssetId>();
